const mustache = require("mustache");
const hiddenFieldGuid = '0e1c0568-776f-4d95-cb15-b5e044d2ac43';
export const GroupOrder = {
    onDocumentLoad
}

const onDocumentLoad = function() {

    var quantityStepperBtns = document.querySelectorAll('.quantity-stepper-btn');
    for (let i = 0; i < quantityStepperBtns.length; i++) {
      quantityStepperBtns[i].addEventListener("click", onQuantityStepperPress);
    }

    function onQuantityStepperPress(e) {
      let target = e.currentTarget;
      let queryString = target.dataset.targetInput;
      let willIncreaseValue = target.dataset.type == "increase";
      let targetIsMobile = target.dataset.targetInput.includes("Mobile");

      if (willIncreaseValue) {
        increaseValue(queryString, targetIsMobile);
      } else {
        decreaseValue(queryString, targetIsMobile);
      }
    }

    function increaseValue(queryString, targetIsMobile) {
      let elms = setUpRelatedInputElements(targetIsMobile, queryString);
      let desktopInput = elms[0];
      let mobileInput = elms[1];
      let increaseBtnDesktop = elms[2];
      let increaseBtnMobile = elms[3];
      
      desktopInput.value++;
      mobileInput.value = desktopInput.value;
      generateOrderState();
      if(desktopInput.value > 0) {
        increaseBtnDesktop.disabled = false;
        increaseBtnMobile.disabled = false;
      }
    }

    function decreaseValue(queryString, targetIsMobile) {
      let elms = setUpRelatedInputElements(targetIsMobile, queryString);
      let desktopInput = elms[0];
      let mobileInput = elms[1];
      let increaseBtnDesktop = elms[2];
      let increaseBtnMobile = elms[3];

      let hash = desktopInput.dataset.hash;
      var summaryWrapperItems = document.querySelectorAll(`li[data-hash='${hash}']`);
      if (summaryWrapperItems.length == 1) {
        handleArticleAdded(hash, false);
      }

      if(desktopInput.value > 0 ) {
        desktopInput.value--;
        mobileInput.value = desktopInput.value;
        generateOrderState();
      }
      
      if (desktopInput.value == 0) {
        increaseBtnDesktop.disabled = true;
        increaseBtnMobile.disabled = true;
      }
    }

    var mobileVariants = document.querySelectorAll('.variants-mobile');
    for (let i = 0; i < mobileVariants.length; i++) {
      let height = mobileVariants[i].offsetHeight;
      mobileVariants[i].dataset.height = height;
      mobileVariants[i].style.height = 0;
    }

    var variantsToggle = document.querySelectorAll('.variants-toggle');
    for (let i = 0; i < variantsToggle.length; i++) {
      variantsToggle[i].addEventListener("click", onTogglePress);
    }

    function onTogglePress(e) {
      let target = e.currentTarget;
      let expandId = target.getAttribute('aria-controls');
      let expand = document.getElementById(expandId);
      target.setAttribute("aria-expanded", toggleAriaExpanded(target));
      expand.classList.toggle('open');
      if (expand.dataset.height) {
        toggleHeight(expand, expand.dataset.height)
      }
    }
    
    function toggleHeight(expand, height) {
      if(expand.classList.contains('open')) {
        expand.style.height = height + "px";
      } else {
        expand.style.height = 0;
      }
    }
    
    function toggleAriaExpanded(target) {
      let targetExpanded = target.getAttribute("aria-expanded");
  
      if (targetExpanded == "true") {
        targetExpanded = "false";
      } else {
        targetExpanded = "true";
      }
  
      return targetExpanded;
    }

    function setUpRelatedInputElements (targetIsMobile ,queryString) {
      let inputDesktopQueryString = queryString;
      let inputMobileQueryString = queryString;

      if (targetIsMobile) {
        inputDesktopQueryString = queryString.replace("-Mobile", "");
      } else {
        inputMobileQueryString = queryString + "-Mobile";
      }

      let desktopInput = document.getElementById(inputDesktopQueryString);
      let mobileInput = document.getElementById(inputMobileQueryString);

      let increaseBtnDesktop = document.querySelectorAll(`[data-target-input="${inputDesktopQueryString}"]`);
      let increaseBtnMobile = document.querySelectorAll(`[data-target-input="${inputMobileQueryString}"]`);

      let elms = [desktopInput, mobileInput, increaseBtnDesktop[1], increaseBtnMobile[0]];
      return elms;
    }

    var changeAmount = document.querySelectorAll('.change-amount');
    for (let i = 0; i < changeAmount.length; i++) {
        let oldValue = null;
        let newValue = null;

        changeAmount[i].addEventListener("focus", function(e) {
          this.select();
        });

        changeAmount[i].addEventListener("keyup", function(e) {
          let targetIsMobile = e.currentTarget.id.includes("Mobile");
          let queryString = e.currentTarget.id;
          let elms = setUpRelatedInputElements(targetIsMobile, queryString);

          let desktopInput = elms[0];
          let mobileInput = elms[1];
          let increaseBtnDesktop = elms[2];
          let increaseBtnMobile = elms[3];
          
          if(e.which !== 40 || e.which !== 38) {
    
            if (changeAmount[i].value == null || changeAmount[i].value == "" ) {
              changeAmount[i].value = oldValue;
            } else {
              newValue = changeAmount[i].value;
              if(targetIsMobile) {
                desktopInput.value  = newValue;
              } else {
                mobileInput.value  = newValue;
              }
              
              if (changeAmount[i].value == 0) {
                increaseBtnDesktop.disabled = true;
                increaseBtnMobile.disabled = true;
              } else {
                increaseBtnDesktop.disabled = false;
                increaseBtnMobile.disabled = false;
              }
    
              generateOrderState();
            }
    
            if( newValue != oldValue) {
              oldValue = newValue;
            }
          }
          
        });

        changeAmount[i].addEventListener("keydown", function(e) {
          let targetIsMobile = e.currentTarget.id.includes("Mobile");
          let queryString = e.currentTarget.id;

          if(e.which === 38) {
            e.preventDefault();
            increaseValue(queryString, targetIsMobile);
          }

          if(e.which === 40) {
            e.preventDefault();
            decreaseValue(queryString, targetIsMobile);
          }

          if (changeAmount[i].value == null || changeAmount[i].value == "" ) {
            changeAmount[i].value = oldValue;
          } else {
            newValue = changeAmount[i].value;
          }
        });

      if (changeAmount.length) {
        generateOrderState();
      }
    }
  
    function generateOrderState(keepSummaryOpen) {
      var products = document.querySelectorAll('[data-product]');
      var totalAmount = 0;
      var open = keepSummaryOpen ? "open" : "";
      var result = {
        "products":[],
        "hasProducts": function () { return this.products.length },
        "totalAmount": totalAmount,
        "open": open
      };
            
      for (let i = 0; i < products.length; i++) {
        var title = products[i].getAttribute("data-product-title"); 
        var hash = products[i].getAttribute("data-product");
        var item = {
          title,
          hash,
          open,
          variations: []
        };
  
        var variations = products[i].querySelectorAll('[data-variation]');
        for (let j = 0; j < variations.length; j++) {
          var variantTitle = variations[j]. getAttribute("data-variation-title");
          var amount = parseInt(variations[j].value);
          var hash = variations[j].getAttribute("data-hash");
          var id = variations[j].id;
          var totalAmountTemp = totalAmount;
          if (amount > 0) {
            totalAmount = totalAmountTemp + amount;
            var variation = {
              "title": variantTitle,
              "amount": amount,
              "id": id,
              hash
            };
            item.variations.push(variation);
          }
        }
        
        if (item.variations.length) {
          result.products.push(item);
        }
      }
      result.totalAmount = totalAmount;
      /* Update Mustache render */
      const mustacheTemplate = document.getElementById('order-item-template').innerHTML;
      const mustacheContainer = document.getElementById('mustache-container');
      const mustacheRendered = mustache.render(mustacheTemplate, result);
      mustacheContainer.innerHTML = mustacheRendered; 
  
      var summaryToggle = document.querySelectorAll('.order-summary-toggle');
      for (let i = 0; i < summaryToggle.length; i++) {
        summaryToggle[i].addEventListener("click", onTogglePress);
      }
      
      var anchorButtons = mustacheContainer.querySelectorAll('[data-anchor]');
      for (let i = 0; i < anchorButtons.length; i++) {
        anchorButtons[i].addEventListener("click", onAnchorPress);
        anchorButtons[i].addEventListener("keyup", onAnchorPress);
      }
  
      var removeVariationButtons = mustacheContainer.querySelectorAll('[data-remove-variation]');
      for (let i = 0; i < removeVariationButtons.length; i++) {
        //TODO Update remove logic
        var button = removeVariationButtons[i];
        button.addEventListener("click", onRemoveVariationPress);
        button.addEventListener("keyup", onRemoveVariationPress);
   
      }
      
      let summaryWrapperItems = document.querySelectorAll('li[data-hash]');
      for (var i = 0; i < summaryWrapperItems.length; i++) {
        handleArticleAdded(summaryWrapperItems[i].dataset.hash, true);
      }

      if (!result.products.length) {
        document.getElementById("order-form").classList.add("hidden");
        window.scrollTo(0, 0);
      } else {
        // parse the object and set it to a hidden form field that will be sent to backend.
        var hiddenJsonDataField = document.querySelector(`[name='${hiddenFieldGuid}']`);
        if (hiddenJsonDataField !== undefined) {
          hiddenJsonDataField.value = JSON.stringify(result);
        }
      }
    }
  
    function onRemoveVariationPress(e) {
      if (e.key === undefined || e.key === "Enter") {
        var id = e.currentTarget.dataset.removeVariation;

        let elms = setUpRelatedInputElements(false, id);
        let desktopInput = elms[0];
        let mobileInput = elms[1];
        let increaseBtnDesktop = elms[2];
        let increaseBtnMobile = elms[3];

        desktopInput.value = 0;
        mobileInput.value = 0;
        increaseBtnDesktop.disabled = true;
        increaseBtnMobile.disabled = true;

        handleArticleAdded( e.currentTarget.dataset.hash, false);
        generateOrderState(true);
      }
    }
    
    function handleArticleAdded(hash, isAdded) {
      let article = document.querySelector(`article[data-product='${hash}']`);
      if (isAdded) {
        article.classList.add('added');
      } else {
        article.classList.remove('added');
      }
    }

    function onAnchorPress(e) {
      if (e.key === undefined || e.key === "Enter") {
        e.preventDefault();
        
        var targetId = e.currentTarget.getAttribute('data-anchor');
        let target = document.getElementById(targetId);
        target.classList.remove("hidden");
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }

    var sectionFilterChips = document.querySelectorAll('[data-product-section-filter]')
    function handleFilterChipsChange() {
      var activeFilterChips = [];
      for (let i = 0; i < sectionFilterChips.length; i++) {
        var filterChip = sectionFilterChips[i];
        if (filterChip.classList.contains("active")) {
          var target = filterChip.getAttribute('data-target');
          if (target !== undefined && target !== null) {
            activeFilterChips.push(target)
          }
        }
      }

      var productSections = document.querySelectorAll('[data-section]');
      for (let i = 0; i < productSections.length; i++) {
        var sectionName = productSections[i].getAttribute('data-section');
        if (!activeFilterChips.includes(sectionName) && activeFilterChips.length) {
          productSections[i].classList.add("hidden");
        } else {
          productSections[i].classList.remove("hidden");
        }
      }
    }

    
    for (let i = 0; i < sectionFilterChips.length; i++) {
      sectionFilterChips[i].addEventListener("click", function(e) {
        e.preventDefault();
        e.currentTarget.classList.toggle("active");

        var countElement = e.currentTarget.querySelector('[data-count]');
        var countActive = ['bg-base-light', 'text-base-dark', 'border-base-light'];
        var countInactive = ['border-base-dark'];
        var btnActive = ['text-base-onDark', 'bg-base-dark', 'hover:bg-base-hoverDark'];

        if (e.currentTarget.classList.contains('active')) {
          countElement.classList.add(...countActive);
          e.currentTarget.classList.add(...btnActive);
          countElement.classList.remove(...countInactive);
        } else {
          countElement.classList.remove(...countActive);
          e.currentTarget.classList.remove(...btnActive);
          countElement.classList.add(...countInactive);
        }

        handleFilterChipsChange();
      })
    }
}